module.exports = __webpack_public_path__ + "static/media/logo-light-en.0bf74227.svg";